function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6953 4.26562C12.9766 4.47656 13.0703 4.82812 12.9531 5.15625L11.1016 9.75H14.5C14.8281 9.75 15.1094 9.9375 15.2031 10.2422C15.3203 10.5469 15.2266 10.875 14.9922 11.0859L8.24219 16.7109C7.96094 16.9219 7.58594 16.9453 7.30469 16.7344C7.02344 16.5234 6.92969 16.1719 7.04688 15.8438L8.89844 11.25H5.5C5.19531 11.25 4.91406 11.0625 4.79688 10.7578C4.67969 10.4531 4.77344 10.125 5.03125 9.91406L11.7812 4.28906C12.0391 4.07812 12.4141 4.05469 12.6953 4.26562Z",
  fill: "#000"
});

function SvgQuickSetupFilledIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickSetupFilledIcon);
export default __webpack_public_path__ + "static/media/quick-setup-filled-icon.0b71fef3.svg";
export { ForwardRef as ReactComponent };